export const RESPONSE_MESSAGE = {
  OK: 'OK',
} as const;
